// SECURITY: TOTAL STORAGE LOCKDOWN - Import FIRST before anything else
import './security/total-storage-lockdown';
// SECURITY: RUNTIME VALIDATOR - Ultra-aggressive monitoring
import './security/runtime-validator';
// SECURITY: Import nuclear cleanup to eliminate ALL price data
import './security/cart-nuclear-cleanup';
// SECURITY: Import localStorage interceptor to prevent future manipulation
import './security/localStorage-interceptor';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './styles/index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
